import { z } from 'zod';
import { VehicleTechnology } from './vehicle.schemas.js';
export const COMPONENT_KINDS = {
    COMPRESSOR: { label: 'Compressor de ar', lifeKm: 300_000, technologies: [VehicleTechnology.DIESEL, VehicleTechnology.EBUS] },
    TURBINA: { label: 'Turbina', lifeKm: 350_000, technologies: [VehicleTechnology.DIESEL] },
    BICO_INJETOR: { label: 'Bicos injetores', lifeKm: 250_000, technologies: [VehicleTechnology.DIESEL] },
    CUBO_RODA: { label: 'Cubos de roda', lifeKm: 400_000, technologies: [VehicleTechnology.DIESEL, VehicleTechnology.EBUS] },
    MOTOR_PARTIDA: { label: 'Motor de partida', lifeKm: 300_000, technologies: [VehicleTechnology.DIESEL] },
    ALTERNADOR: { label: 'Alternador', lifeKm: 200_000, technologies: [VehicleTechnology.DIESEL] },
    BATERIA_TRACAO: { label: 'Baterias de tração', lifeKm: 600_000, technologies: [VehicleTechnology.EBUS] },
};
export const COMPONENT_KIND_KEYS = Object.keys(COMPONENT_KINDS);
export function componentKindsFor(technology) {
    return COMPONENT_KIND_KEYS.filter((k) => COMPONENT_KINDS[k].technologies.includes(technology));
}
/** Por que o componente anterior saiu (e este entrou). */
export const COMPONENT_CHANGE_REASONS = {
    FALHA: 'Falhou em serviço',
    PREVENTIVA: 'Troca preventiva (fim da vida)',
    GARANTIA: 'Troca em garantia',
    INICIAL: 'Carga inicial (sem anterior)',
};
/** Acima de 85% da vida esperada o componente entra na lista de atenção. */
export const COMPONENT_NEAR_LIFE_PCT = 85;
const optionalInt = () => z.preprocess((v) => (v === '' || v === null || v === undefined ? undefined : v), z.coerce.number().int().min(0).optional());
export const installComponentSchema = z.object({
    vehicleId: z.string().uuid('Escolha o carro'),
    kind: z.enum(COMPONENT_KIND_KEYS),
    serialNumber: z.string().trim().max(40).optional(),
    /** Km do carro na instalação; sem valor, usa o km atual. */
    installedAtKm: optionalInt(),
    installedAt: z.coerce.date().optional(),
    /** Sem valor, usa a vida esperada do tipo. */
    expectedLifeKm: optionalInt(),
    reason: z.enum(Object.keys(COMPONENT_CHANGE_REASONS)).default('FALHA'),
    note: z.string().trim().max(255).optional(),
});
//# sourceMappingURL=component.schemas.js.map